import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "letter",
  "use": "letter-usage",
  "viewBox": "0.974 0 18.033 13.526",
  "content": "<symbol viewBox=\"0.974 0 18.033 13.526\" id=\"letter\"><path d=\"M.974.114v13.412h18.033V0L.974.114zm9.077 7.748L2.742 1.104 17.46 1.01l-7.409 6.852zm-8.077 4.664V1.755l5.495 5.081-4.247 3.927.678.734 4.305-3.98 1.846 1.707 1.976-1.827 4.436 4.101.68-.734-4.378-4.048 5.242-4.848v10.659H1.974z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./application/components/dumb/icon/src/letter.svg
// module id = 170
// module chunks = 0